module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/kiosk-close-button-11f7794110ab16e341dd855a6176d113.svg";